/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

const addProduct = createAction('asset/addProduct');

export default addProduct;
